export var LinearProgressOverrides = function (theme) {
    var progressBackground = theme.palette.type === 'light' ? theme.palette.brand.light : theme.palette.brand.dark;
    return {
        MuiLinearProgress: {
            root: {
                height: '6px',
                borderRadius: '6px',
            },
            bar: {
                borderRadius: '6px',
            },
            colorPrimary: {
                backgroundColor: progressBackground,
            },
            barColorPrimary: {
                backgroundColor: theme.palette.brand.main,
                border: "2px solid ".concat(theme.palette.brand.main),
            },
        },
    };
};
//# sourceMappingURL=LinearProgress.overrides.js.map